import { render, staticRenderFns } from "./FeedbackBar.vue?vue&type=template&id=545353d4&"
import script from "./FeedbackBar.vue?vue&type=script&lang=js&"
export * from "./FeedbackBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports